import { AbstractApi } from ".";

class ExtractApi extends AbstractApi {
    baseUrl = '/api/extract';

    store(formData) {
        return this.post(this.baseUrl, formData);
    }

    show(id) {
        return this.get(`${this.baseUrl}/${id}`);
    }

    result(id, task = 'text') {
        return this.get(`${this.baseUrl}/${id}/result?task=${encodeURIComponent(task)}`);
    }

    downloadUrl(id, format = 'txt', task = 'text') {
        return `${this.baseUrl}/${id}/download?format=${encodeURIComponent(format)}&task=${encodeURIComponent(task)}`;
    }
}

export default new ExtractApi();
